import { CSSObject } from "@emotion/react";
import {
  partialCtaDefaultLinearGradientBackground,
  partialCtaHoverLinearGradientBackground,
} from "@/components/AIComponents/AiComponents.style";

export const buttonContainerStyles: CSSObject = {
  display: "flex",
  justifyContent: "flex-end",
  ...partialCtaDefaultLinearGradientBackground,
  "&:hover": partialCtaHoverLinearGradientBackground,
};
